export var isBrightColour = colour => {
  if (!colour || !colour.startsWith('#') || colour.length !== 7) {
    return true;
  }
  var rgb = [parseInt(colour.substring(1, 3), 16), parseInt(colour.substring(3, 5), 16), parseInt(colour.substring(5), 16)];
  if (rgb.some(isNaN)) {
    return true;
  }
  var luminance = 0.2126 * rgb[0] / 255 + 0.7152 * rgb[1] / 255 + 0.0722 * rgb[2] / 255;
  return luminance > 0.5;
};